// @flow
import * as React from "react"
import ModalHeader from "modals/_Header"
import ModalContent from "modals/_Content"

type Props = {|
  title: string,
  back: Function,
  clear: Function,
  children: React.Node,
|}

const sanitizeString = (s: string) =>
  s
    .split("_")
    .map(x => `${x[0].toUpperCase()}${x.slice(1)}`)
    .join(" ")

const Submodal = ({ title, back, clear, children }: Props) => (
  <React.Fragment>
    <ModalHeader back={back} title={sanitizeString(title)} clear={clear} />
    <ModalContent>{children}</ModalContent>
  </React.Fragment>
)

export default Submodal



// WEBPACK FOOTER //
// ./src/modals/SetActivityFilters/EnumFilterSubmodal/Submodal/index.js